import { render } from "./breadcrumb.vue?vue&type=template&id=5044a4e0&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=5044a4e0&scoped=true&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5044a4e0"]])

export default __exports__